
import { RouteObject } from 'react-router';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const OrthoK = lazy(() => import('../pages/ortho-k/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/ortho-k',
    element: <OrthoK />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
